import { Component } from '@angular/core';

@Component({
  selector: 'app-availed-scheme-graph-svg',
  standalone: true,
  template: `<svg
    width="100%"
    height="auto"
    viewBox="0 0 261 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M39.75 98.4482C24.2535 102.765 4.07692 119.044 4.07692 119.044L0 120.692V159H265V0C265 0 253.581 3.44928 247.163 7.41451C232.575 16.4285 234.14 31.824 220.663 42.4275C207.972 52.4131 198.416 54.6889 183 59.5C163.584 65.5596 150.546 60.0554 131.481 67.1425C110.689 74.8714 105.552 92.8558 84.0865 98.4482C67.3313 102.813 56.4296 93.8023 39.75 98.4482Z"
      fill="#772E90"
    />
  </svg> `,
})
export class AvailedSchemeGraphSvgComponent {}
